import { isString } from "@grandvisionhq/utils";
import { getProductInventoryChannels } from "../../../../utils/mappers/server-to-client/utils/get-product-inventory-channels.js";
import { getPurchaseTypePrices } from "../../../../utils/mappers/server-to-client/utils/get-purchase-type-prices.js";
import { getProductAssets } from "../../../../utils/mappers/server-to-client/utils/get-product-assets.js";
import { convertCentToDecimal } from "../../../../utils/mappers/server-to-client/utils/convert-cent-to-decimal.js";
import { getProductMedia } from "../../../../utils/mappers/server-to-client/utils/get-product-media.js";
import { getMetaTitle, getMetaDescription } from "../../../../utils/mappers/server-to-client/utils/get-product-seo-info.js";
import { getProductImageUrl } from "../../../../utils/mappers/server-to-client/utils/get-product-image-url.js";
import { getProductTag } from "../../../../utils/mappers/server-to-client/utils/get-product-tag.js";
import { getIsAvailableForInstoreSubscription } from "../../../../utils/mappers/server-to-client/utils/get-is-available-for-instore-subscription.js";
import { getIsAvailableForSubscription } from "../../../../utils/mappers/server-to-client/utils/get-is-available-for-subscription.js";
const mapServerToVariantBase = (serverVariant, serverProduct, slug, locale, priceSegmentChannelKey) => {
  const { variantTypeDetails, description: variantDescription, displayName, sku } = serverVariant;
  const purchaseTypePrices = getPurchaseTypePrices(
    serverVariant.priceList,
    locale,
    priceSegmentChannelKey
  );
  if (!purchaseTypePrices) {
    console.error(
      `Cannot render variant with sku "${sku}" because it does not have a price for single-purchase`
    );
    return;
  }
  const { description: productDescription } = serverProduct;
  const assets = getProductAssets(serverVariant.assets);
  const bestPrice = convertCentToDecimal(serverVariant.bestPrice);
  const description = [variantDescription, productDescription].find(isString);
  const media = getProductMedia(serverVariant.media);
  const metaTitle = getMetaTitle(serverVariant, serverProduct);
  const metaDescription = getMetaDescription(serverVariant, serverProduct);
  const ogImageUrl = getProductImageUrl(serverVariant.media);
  const inventoryChannels = getProductInventoryChannels(serverVariant.inventory);
  const productTag = getProductTag(serverVariant.tags);
  const channelAvailability = variantTypeDetails.channelAvailability;
  const isAvailableForInStoreSubscription = getIsAvailableForInstoreSubscription(
    serverVariant,
    purchaseTypePrices
  );
  const isAvailableForSubscription = getIsAvailableForSubscription(
    serverVariant,
    purchaseTypePrices
  );
  let recommendedCategoryKey;
  if ("recommendedCategoryKey" in variantTypeDetails) {
    recommendedCategoryKey = variantTypeDetails.recommendedCategoryKey ?? void 0;
  }
  return {
    assets,
    bestPrice,
    channelAvailability,
    displayName,
    description,
    shortDescription: serverVariant.header ?? void 0,
    sku,
    slug,
    variantUsps: serverVariant.usps,
    productTag,
    isExcludedFromCheckout: !!serverVariant.isExcludedFromCheckout,
    isAvailableForInStoreSubscription,
    isAvailableForSubscription,
    media,
    purchaseTypePrices,
    promotionIdentifier: serverVariant.promotionIdentifier ?? void 0,
    recommendedCategoryKey,
    seoConfig: {
      metaTitle,
      metaDescription,
      ogImageUrl
    },
    isPublished: serverVariant.isPublished,
    stock: {
      enableStockIndicator: !serverVariant.isExcludedFromCheckout,
      isAllowBackOrder: !!serverVariant.isAllowBackOrder,
      stockCount: serverVariant.inventory?.totalQuantity ?? 0
    },
    inventoryChannels
  };
};
export {
  mapServerToVariantBase
};
//# sourceMappingURL=map-server-to-variant-base.js.map
